"use client";

import Link from "next/link";
import { useFormState, useFormStatus } from 'react-dom';
import { authenticate } from '@/app/lib/actions';

export default function LoginForm () {
    const [errorMessage, dispatch] = useFormState(authenticate, undefined);
    return (
        <>
            <form action={dispatch} className="pt-2">
              <div className="mb-1">
                <h1 className="fw-bold  fs-2 text-black alt-font p-0 m-0">Login</h1>
                <p className=" fs-6 m-0" style={{color: "#868D99"}}>Log in to Xylo and elevate<br/>your content experience!</p>
              </div>

              <div className="pt-2">
                <div className="mb-1">
                  <label className="form-label text-black">Email</label>
                  <input 
                    id="email"
                    type="email"
                    name="email" 
                    style={{borderColor: "#E4E6EE"}}
                    className="form-control"
                  />
                </div>
                <div className="mb-1">
                  <label className="form-label text-black">Password</label>
                  <input 
                    id="password"
                    type="password"
                    name="password"
                    style={{borderColor: "#E4E6EE"}}
                    className="form-control"
                  />
                </div>
                <div className="d-flex w-100 justify-content-end">
                  <a href="/forgot-password" style={{color: "#9D3DE3"}}><span className="-50 fs-6">forgot password ?</span></a>
                </div>
              </div>

              <div className="d-flex h-8 align-items-end gap-1" aria-live="polite" aria-atomic="true">
                {errorMessage && (
                  <>
                    {/* <ExclamationCircleIcon className="h-5 w-5 text-red-500" /> */}
                    <p className="text-danger fs-6">{errorMessage}</p>
                  </>
                )}
              </div>

              <div className="pt-1">
                <div>
                  <LoginButton/>
                </div>
                <p className="font-weight-bold text-secondary fs-6 py-2">Don&apos;t have an account yet ?<br/>
                  <a href="/buy-credits"  style={{color: "#9D3DE3"}}><span className="-50 fs-6">Choose a package and get registered </span></a>
                </p>
              </div>
            </form>

        </>
    )
}

function LoginButton() {
    const { pending } = useFormStatus();
   
    return (
        <>
            <button 
              type="submit"
              disabled={pending} 
              className="btn btn-black rounded w-100 d-flex align-items-center justify-content-center py-2 px-4 rounded-lg shadow-md hover-bg-white focus-outline-none focus-ring focus-ring-primary-400 focus-ring-opacity-75"
            >
              <span>
                {pending ? "Loading ..." : "LOG IN"}
              </span>
            </button>

        </>
    );
  }